import React from 'react';
import PropTypes from 'prop-types';
import {Card, Col, Row} from "react-bootstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {useNavigate} from "react-router-dom";
import BaseDetailsPageHeader from "./BaseDetailsPageHeader";

const DetailsPageHeader = ({title, iconText, iconType}) => {
    return (<BaseDetailsPageHeader title={title} iconBar={
        <p className={"h6 text-uppercase text-600"}>
            {iconText}
            <FontAwesomeIcon icon={iconType} className={"ms-2"} />
        </p>
    }/> );
}

DetailsPageHeader.propTypes = {
    title: PropTypes.node.isRequired,
    iconText: PropTypes.string.isRequired,
    iconType: PropTypes.string.isRequired
}
export default DetailsPageHeader